import { Link } from "@remix-run/react";
import { PackageOpen } from "lucide-react";
import Button from "../theme/Button";

type Props = {
  storeName: string;
  /** Shorter line for tight layouts */
  compact?: boolean;
};

export function StoreEmptyProducts({ storeName, compact }: Props) {
  return (
    <div
      className={`flex w-full flex-col items-center justify-center rounded-2xl border border-dashed border-gray-200 bg-white/80 px-6 text-center shadow-sm ${
        compact ? "py-10" : "py-14 md:py-16"
      }`}
    >
      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-orange-50 text-orange-600">
        <PackageOpen className="h-7 w-7" strokeWidth={1.5} />
      </div>
      <h3 className="mt-4 text-base font-semibold text-gray-900">
        No products listed yet
      </h3>
      <p className="mt-2 max-w-md text-sm text-gray-500">
        {storeName} hasn&apos;t added any products to their storefront. Check
        back soon, or browse other suppliers on BulkBuyPlace.
      </p>
      <Button mode="primary" className="mt-6">
        <Link to="/suppliers">Browse stores</Link>
      </Button>
    </div>
  );
}
